var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('h3',[_vm._t("Title",function(){return [_vm._v("An error occured")]})],2),_c('h4',[_vm._t("SubTitle")],2),_c('p',[_vm._t("Content",function(){return [_vm._v("An error occured while processing your request. We are sorry for that.")]})],2),_c('div',{staticClass:"actions"},[_vm._t("Actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }